<button nz-button nz-dropdown [nzSize]="'small'" [nzDropdownMenu]="menu" [nzTrigger]="'click'">
  <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
  Add Member
</button>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    @for (user of userList(); track $index) {
      <li nz-menu-item (click)="onMemberClick(user)">
        <app-board-icon-title [board]="user"></app-board-icon-title>
      </li>
    }
  </ul>
</nz-dropdown-menu>
